module.exports = function (app) {
    app.controller('pages.account.partner-products', ['$scope',
        function ($scope) {
            $scope.heading = "Partner Products and Services Authorization";
        }
    ]);
}